import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'xm-segment-switch-banner',
    styleUrls: ['./segment-switch-banner.scss'],
    templateUrl: './segment-switch-banner.html',
    standalone: false
})
export class SegmentSwitchBanner implements OnInit {
    @Input() public pageData: CmsSegmentSwitch;
    
    public imageOptions: MediaImageOptions;

    public ngOnInit(): void {
        this.imageOptions = {
            mobile: {
                base: this.pageData.mobileImage
            },
            smallDesktop: {
                base: this.pageData.desktopImage
            }
        };
    }
}
